"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _IconWrapper = _interopRequireDefault(require("./IconWrapper"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Habitat = function Habitat(_ref) {
  var viewBox = _ref.viewBox;
  return /*#__PURE__*/_react.default.createElement(_IconWrapper.default, {
    viewBox: viewBox
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M15.0079 12.3115C14.5828 12.7244 14.3933 13.2139 14.3933 13.6885C14.3933 14.0699 14.6719 14.3612 15.0079 14.3612C15.3439 14.3612 15.6082 14.0699 15.6082 13.6885C15.6082 13.2139 15.4459 12.7244 15.0079 12.3115ZM17.1289 11.3174C16.5287 11.3174 15.914 11.5472 15.433 11.9286C15.9442 12.4496 16.2357 13.0758 16.2357 13.6735C16.2357 14.2546 15.8121 14.9423 15.0079 14.9423C14.2037 14.9423 13.7642 14.2546 13.7642 13.6735C13.7642 13.0758 14.0573 12.4496 14.5699 11.9286C14.086 11.5472 13.4857 11.3174 12.8854 11.3174C11.6878 11.3174 10.7213 12.3265 10.7213 13.9018C10.7213 16.0896 12.3455 18.0777 15.0079 19.2415C17.6703 18.0777 19.2787 16.0896 19.2787 13.9018C19.2787 12.3265 18.328 11.3174 17.1289 11.3174ZM21.328 10.9194L15.0079 5.87099L8.6735 10.9194V20.3122H9.4777C11.2038 20.3122 12.7691 20.0509 14.1305 19.5779C11.57 18.2625 10.0349 16.1662 10.0349 13.9018C10.0349 11.9752 11.3359 10.6747 12.9012 10.6747C13.7054 10.6747 14.4378 11.0411 15.0079 11.5006C15.578 11.0411 16.3089 10.6747 17.1146 10.6747C18.6799 10.6747 19.9665 11.9752 19.9665 13.9018C19.9665 16.1662 18.4315 18.2625 15.871 19.5779C17.2309 20.0509 18.8106 20.3122 20.5381 20.3122H21.328V10.9194ZM20.5956 21C18.4745 21 16.5875 20.617 15.0079 19.9758C13.4268 20.617 11.5398 21 9.4188 21H8V10.5681L14.9935 5L22 10.5681V21H20.5956Z",
    stroke: "#231F20"
  }));
};

Habitat.propTypes = {
  viewBox: _propTypes.PropTypes.string
};
Habitat.defaultProps = {
  viewBox: '0 0 30 30'
};
var _default = Habitat;
exports.default = _default;